module.exports = {
  apiURL: process.env.REACT_APP_API_URL || 'http://localhost:3010',
  landingPageVideoUrl: 'https://vimeo.com/157140504',
  scrollableRoutes: ['/home', '/news', '/about', '/case_studies',
    '/contact', '/careers', '/graduates', '/privacy',
    '/careers/seniorengineer', '/careers/businessanalyst'],
};



// WEBPACK FOOTER //
// ./src/constant/config.js